/**
 * Determines if the request is to our own APIs.
 */
export const isOurApi = (axiosConfig) => {
    if (!axiosConfig) {
        return false;
    }
    const { url, baseURL } = axiosConfig;
    if (!url) {
        return baseURL && isOurUrl(baseURL);
    }
    const isUrlAbsolute = isUrlAbsoluteRegex.test(url);
    if (!isUrlAbsolute) {
        return baseURL && isOurUrl(baseURL);
    }
    return isOurUrl(url);
};
/**
 * Regex to determine if a URL is absolute or relative.
 */
const isUrlAbsoluteRegex = new RegExp('^(?:[a-z]+:)?//', 'i');
/**
 * Determines if the URL is to our own APIs.
 */
const isOurUrl = (url) => url.indexOf('.microsoft.com') > -1 ||
    url.indexOf('msrc.windows.net') > -1 ||
    url.indexOf('.core.windows.net') > -1 ||
    url.indexOf('.azurewebsites.net') > -1 ||
    url.indexOf('localhost') > -1;
